import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TrMoneyComponent } from './tr-money.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CurrencyMaskModule,
    ],
    exports: [ TrMoneyComponent ],
    declarations: [ TrMoneyComponent ],
})
export class TrMoneyModule {}
